import React from 'react'
import "../styles/Projects.scss";
import Card from './Card';


function Projects() {
    let projects = {};
    projects['news_portal'] = {
        type: 'Django (BackEnd + FrontEnd)',
        status: 'SkillFactory homework project',
        name: 'Django project "News Portal".',
        description: 'Новостной портал, созданный на фреймворке Django. Имеет следующую структуру: возможность '+
            'зарегистрироваться в качестве автора, разместить статью в одной из новостных категорий, присвоить ей '+
            'статус новости или статьи. Реализована проверка прав доступа. Под каждой новостью/статьей можно оставлять '+
            'комментарии. При просмотре новостей используется сортировка по дате, работает фильтр цензурных фраз. Реализована '+
            'возможность подписки на новые статьи по категориям и еженедельная рассылка на почту списка новых статей. '+
            'Сделано логирование ошибок и предупреждений разных уровней в разные файлы (general.log, errors.log, security.log)',
        git: 'https://github.com/aerastov/SkillFactory_D13.git',
        stack: 'django, celery, redis',
        img: require('../media/News_Portal.jpg'),
    }
    projects['MMORPG_board'] = {
        type: 'Django (BackEnd + FrontEnd)',
        status: 'SkillFactory homework project',
        name: 'Django project "MMORPG board".',
        description: 'Доска объявлений для геймеров, основанная на фреймворке Django. Имеет возможности: '+
            'зарегистрироваться по e-mail, получив письмо с кодом подтверждения регистрации. '+
            'После регистрации становится доступно создание и редактирование объявлений. Объявления состоят '+
            'из заголовка и текста, внутри которого могут быть картинки, встроенные видео и другой контент. '+
            'Пользователи могут отправлять отклики на объявления других пользователей. При отправке отклика '+
            'пользователь должен получить e-mail с оповещением о нём. Также пользователю должна быть доступна '+
            ' приватная страница с откликами на его объявления, внутри которой он может фильтровать отклики по '+
            ' объявлениям, удалять их и принимать.',
        git: 'https://github.com/aerastov/SkillFactory_D16.git',
        stack: 'django, allauth, celery, redis',
    }
    projects['docker'] = {
        type: 'Docker-compose',
        status: 'SkillFactory homework project',
        name: 'Docker image with Django, including postgres, nginx and gunicorn.',
        description: 'Собранный на докере образ Django, включает в себя базу данных postgres, '+
            'http-сервер nginx и wsgi server gunicorn. Проброшены на локальный хост папки для дальнейшей разработки '+
            'проекта (django, static, media). Файлы базы данных postgres так же сохраняются на хосте (папка postgres) '+
            'для сохранения внесенных изменений в случае перезапуска контейнеров. Готов к дальнейшей разработке.',
        git: 'https://github.com/aerastov/SkillFactory_G4.git',
        stack: 'Docker-compose, django, postgres, nginx, gunicorn',
    }
    projects['news_websocket'] = {
        type: 'BackEnd aiohttp + FrontEnd jQuery',
        status: 'SkillFactory homework project',
        name: 'Project on aiohttp, allows you to open websockets for messaging, homemade ping.',
        description: 'Асинхронное BackEnd приложение на aiohttp, которое позволяет подсоединяться через websocket, ' +
            'отправленное сообщение с любого клиента транслируется на все открытые websockets, реализован контроль ' +
            'за соединениями между клиентом и сервером при помощи ping - pong запросов.',
        git: 'https://github.com/aerastov/SkillFactory_F9',
        stack: 'Python, aiohttp, jQuery, websocket',
    }
    projects['weather'] = {
        type: 'SPA FrontEnd',
        status: 'SkillFactory homework project',
        name: 'Getting data from OpenWeather',
        description: 'Проект на React - домашнее задание от компании SkillFactory.  Получение данных о погоде через api с ресурса Open' +
            ' Weather. Использована сборка WebPack с ручной настройкой конфигов, применением типизации typescript и ' +
            'адаптивного дизайна.',
        git: 'https://github.com/aerastov/SkillFactory_F1',
        deploy: 'https://aerastov.github.io/SkillFactory_F1/',
        stack: 'WebPack + main config, React, TypeScript',
        img: require('../media/weather.jpg'),
    }
    projects['recipes'] = {
        type: 'BackEnd django + SPA FrontEnd',
        status: 'SkillFactory homework project',
        name: 'Fullstack app with recipes of dishes',
        description: 'Фулстек-приложение с рецептами блюд, которое использует Django Rest Framework, автодокументацию ' +
            'OpenAPI+Swagger и react-router.',
        git: 'https://github.com/aerastov/SkillFactory_F4',
        stack: 'WebPack, React, Router, Django, DRF, Swagger',
    }

    projects['some'] = {
        type: 'BackEnd',
        status: 'SkillFactory homework project',
        name: 'some project',
        description: 'Данные о проекте скоро будут добавлены',
    }
    projects['some2'] = {
        type: 'BackEnd',
        status: 'SkillFactory homework project',
        name: 'some project',
        description: 'Данные о проекте скоро будут добавлены',
    }
    projects['some3'] = {
        type: 'BackEnd',
        status: 'SkillFactory homework project',
        name: 'some project',
        description: 'Данные о проекте скоро будут добавлены',
    }
    projects['currency_convertor'] = {
        type: 'Python 3',
        status: 'SkillFactory homework project',
        name: 'Currency convertor',
        description: 'Telegram-бот, который конвертирует валюту. При написании бота использована библиотека pytelegrambotapi, ' +
            'опрос сервера telegram реализован методом polling. При вводе в чат запроса типа "доллар рубль 100" бот присылает ' +
            'ответ, сколько будет в рублях 100 долларов по текущему курсу. Поскольку это тестовый бот, валюты всего 3 - рубль, ' +
            'доллар и евро. Бот запущен на хостинге, поэтому его работу можно просто проверить в чате @SkillFactory_my_bot (набрать /start)',
        git: 'https://github.com/aerastov/SkillFactory_C5',
        deploy: 'https://t.me/SkillFactory_my_bot',
        stack: 'Python 3, pytelegrambotapi, polling',
    }
    projects['great_sea_battle'] = {
        type: 'Python 3',
        status: 'SkillFactory homework project',
        name: 'Great sea battle to the death',
        description: 'Консольная игра против компьютера морской бой, написанная на python с объектно-ориентированной парадигмой программирования (OOPs). ' +
            'Использованы классы функции, обработка исключений, циклы, условия и другие базовые элементы языка python.',
        git: 'https://github.com/aerastov/SkillFactory_C2',
        stack: 'Python 3, OOPs in python',
        img: require('../media/great_sea_battle.jpg'),
    }
    projects['tic-tac-toe_game'] = {
        type: 'Python 3',
        status: 'SkillFactory homework project',
        name: 'Tic-tac-toe game',
        description: 'Консольная игра против компьютера крестики-нолики, написанная на python в функциональном ' +
            'стиле программирования. Использованы функции, циклы, условия и другие базовые элементы языка python.',
        git: 'https://github.com/aerastov/SkillFactory_B5',
        stack: 'Python 3, functional-programming',
        img: require('../media/tic-tac-toe.png'),
    }
    // console.log(Object.keys(projects))
    // Object.keys(projects).map(function(key) {
    //     console.log("Key:", key, "Value:", projects[key])
    // })

    return (
        <div className={'projects'}>
            {Object.keys(projects).map((key) =>
                <Card project={projects[key]} key={projects[key].name}/>
            )}

        </div>

    );
};

export default Projects
